import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  @Input('typeColor') typeColor: any;
  @Input('message') message: any;

  staticAlertClosed = false;

  constructor() { }


  ngOnInit(): void {
    setTimeout(() => {
      this.staticAlertClosed = true
    }, 5000);


  }

}
